import { ButtonBase, type SxProps, type Theme, Typography } from '@mui/material';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

export function ClearAllButton({ onClick, disabled, sx }: Props) {
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      sx={
        [
          {
            color: disabled ? 'neutral.lighter' : 'neutral.dark',
            alignSelf: 'center',
            flex: 'none',
            px: 1,
            '&:not(:disabled):hover': { color: 'greens.main' },
          },
          sx,
        ] as SxProps<Theme>
      }
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 300, textDecoration: 'underline' }}>
        Clear All
      </Typography>
    </ButtonBase>
  );
}
